import { Fragment, useEffect, useCallback } from 'react'
import { Provider, useSelector, useDispatch } from 'react-redux'

import { configureStore } from 'catalog/redux/store'
import { Actions as SkusActions } from 'catalog/redux/modules/skus'

import { Buybox } from './containers/Buybox'
import { ExclusiveSaleSiteMessage } from './components/ExclusiveSaleSiteMessage'
import { PriceTag } from './containers/PriceTag'

const store = configureStore()

const ProductWithProvider = (props) => {
  return (
    <Provider store={store}>
      <Product {...props} />
    </Provider>
  )
}

const Product = ({
  isAssistedSale,
  isBlackWeekend,
  isDataLayer,
  limitQuantity,
  product,
  selectedSeller,
  isProductExclusiveMarketPlace
}) => {
  const productData = JSON.parse(product)

  const { skus } = useSelector((state) => state.skus)

  const dispatch = useDispatch()

  useEffect(() => {
    fetchSkus()
  }, [fetchSkus])

  const fetchSkus = useCallback(() => {
    if (!skus.length) {
      dispatch(SkusActions.getSkus(productData.id))
    }
  }, [skus, dispatch, productData.id])

  return (
    <Fragment>
      <PriceTag
        isAssistedSale={!!isAssistedSale}
        isBlackWeekend={!!isBlackWeekend}
        product={productData}
        seller={JSON.parse(selectedSeller)}
      />
      <Buybox
        isAssistedSale={isAssistedSale}
        isDataLayer={isDataLayer}
        limitQuantity={limitQuantity}
        product={productData}
      />
      {/* TODO: Rever este componente na virada para nova arquitetura da página */}
      {!!isProductExclusiveMarketPlace && (
        <ExclusiveSaleSiteMessage visibility="mobile"/>
      )}
    </Fragment>
  )
}

export default ProductWithProvider
